import find from 'lodash/find';
import Moment from 'moment';
import {
  ACCESS_END_FIELD_ID,
  ACCESS_START_FIELD_ID,
  ANNOUNCEMENT_FIELD_ID,
  END_FIELD_ID,
  ETICKET_FIELD_ID,
  EXPIRATION_DATE_FIELD_ID,
  FLASH_FIELD_ID,
  OFFER_END_FIELD_ID,
  OFFER_START_FIELD_ID,
  ONSALE_FIELD_ID,
  PRICE_CODE_END_FIELD_ID,
  PRICE_CODE_START_FIELD_ID,
  PRICE_LEVEL_END_FIELD_ID,
  PRICE_LEVEL_START_FIELD_ID,
  PROMO_VISIBLE_END_DATE,
  PROMO_VISIBLE_START_DATE,
  STANDARD_DELIVERY_DATE_FIELD_ID,
  START_FIELD_ID,
} from '../components/RelativeDateAndTime/constants';
import { dateFormats } from '../../common/constants/dateFormats';
import calculateRelativeDate from './CalculateRelativeDate';
import { transformDateFieldToRDAT } from './formatReceiveRDAT';
import { formatDateTimeForAPI, ONE_DAY, THREE_HOURS } from './DateFormatting';

export const receiveAndFormatEvent = (event, flag) => {
  const eventCopy = Object.assign({}, event);
  const dates = {
    flashDeliveryStartDate: {
      date: event.flashSeatsDeliveryDate || '',
      fieldId: FLASH_FIELD_ID,
      isRelative: false,
    },
    eTicketStartDate: {
      date: event.eTicketDeliveryDate || '',
      fieldId: ETICKET_FIELD_ID,
      isRelative: false,
    },
    standardDeliveryDate: {
      date: event.standardDeliveryDate || '',
      fieldId: STANDARD_DELIVERY_DATE_FIELD_ID,
      isRelative: false,
    },
    announcementDate: {
      date: (event.aXSEvent && event.aXSEvent.announceDateTime) || '',
      fieldId: ANNOUNCEMENT_FIELD_ID,
      isRelative: false,
    },
    generalOnsaleDate: {
      date:
        event.generalOnsaleDate &&
        !event.generalOnsaleDate.includes('0001-01-01')
          ? event.generalOnsaleDate
          : '',
      fieldId: ONSALE_FIELD_ID,
      isRelative: false,
    },
    eventStartDate: {
      date: event.startDate || '',
      fieldId: START_FIELD_ID,
      isRelative: false,
    },
    eventEndDate: {
      date: event.endDate || '',
      fieldId: END_FIELD_ID,
      isRelative: false,
    },
    expirationDate: {
      date: (event.aXSEvent && event.aXSEvent.expirationDateTime) || '',
      fieldId: EXPIRATION_DATE_FIELD_ID,
      isRelative: false,
    },
  };

  if (flag) {
    const eTicketStartDate =
      (event.eTixDeliveryDate &&
        transformDateFieldToRDAT(event.eTixDeliveryDate)) ||
      dates.eTicketStartDate;
    const eventEndDate =
      (event.eventEndDate && transformDateFieldToRDAT(event.eventEndDate)) ||
      dates.eventEndDate;
    const flashDeliveryStartDate =
      (event.flashDeliveryDate &&
        transformDateFieldToRDAT(event.flashDeliveryDate)) ||
      dates.flashDeliveryStartDate;
    const standardDeliveryDate =
      (event.standardDelivery &&
        transformDateFieldToRDAT(event.standardDelivery)) ||
      dates.standardDeliveryDate;
    const announcementDate =
      event.aXSEvent && event.aXSEvent.announcementDate
        ? transformDateFieldToRDAT(event.aXSEvent.announcementDate)
        : dates.announcementDate;
    Object.assign(
      dates,
      { eventEndDate },
      { eTicketStartDate },
      { flashDeliveryStartDate },
      { standardDeliveryDate },
      { announcementDate }
    );
  }

  const doorPriceHigh =
    (eventCopy.aXSEvent && eventCopy.aXSEvent.doorPriceHigh) || '';
  const doorPriceLow =
    (eventCopy.aXSEvent && eventCopy.aXSEvent.doorPriceLow) || '';
  const ticketPriceHigh =
    (eventCopy.aXSEvent && eventCopy.aXSEvent.ticketPriceHigh) || '';
  const ticketPriceLow =
    (eventCopy.aXSEvent && eventCopy.aXSEvent.ticketPriceLow) || '';

  if (eventCopy.aXSEvent) {
    eventCopy.aXSEvent.doorPrice = `${doorPriceLow} - ${doorPriceHigh}`;
    eventCopy.aXSEvent.ticketPrice = `${ticketPriceLow} - ${ticketPriceHigh}`;
  }

  delete eventCopy.eTicketDeliveryDate;
  delete eventCopy.eTixDeliveryDate;
  delete eventCopy.endDate;
  delete eventCopy.eventEndDate;
  delete eventCopy.eventStartDate;
  delete eventCopy.flashDeliveryDate;
  delete eventCopy.flashSeatsDeliveryDate;
  delete eventCopy.standardDeliveryDate;
  delete eventCopy.standardDelivery;
  delete eventCopy.generalOnsaleDate;
  delete eventCopy.onsaleDate;
  delete eventCopy.startdate;
  eventCopy &&
    eventCopy.zones &&
    eventCopy.zones.forEach((zone) => {
      if (zone.fSEventConfig && zone.fSEventConfig.listingExpirationDate) {
        zone.fSEventConfig.listingExpirationDate = transformDateFieldToRDAT(
          zone.fSEventConfig.listingExpirationDate
        );
      }
    });

  return Object.assign(eventCopy, { dates });
};
export const receiveAndFormatTemplateBaseEvent = (event, _axsEvent, flag) => {
  const eventCopy = Object.assign({}, event);
  const now = Moment().format(dateFormats.API_DATE_TIME_FORMAT);
  const startDate = flag ? event.eventStartDate.dateTime : event.startDate;
  const axsEvent = _axsEvent ? _axsEvent : event.aXSEvent;

  // Per guidance from CS, we set the event end date to 3am at night.
  const endDate = Moment(startDate, dateFormats.API_DATE_TIME_FORMAT)
    .add(ONE_DAY.value, ONE_DAY.unit)
    .set(THREE_HOURS.unit, THREE_HOURS.value)
    .format(dateFormats.API_DATE_TIME_FORMAT);

  // set non relative dates
  const dates = {
    flashDeliveryStartDate: {
      date: now,
      fieldId: FLASH_FIELD_ID,
      isRelative: false,
    },
    eTicketStartDate: {
      date: now,
      fieldId: ETICKET_FIELD_ID,
      isRelative: false,
    },
    standardDeliveryDate: {
      date: now,
      fieldId: STANDARD_DELIVERY_DATE_FIELD_ID,
      isRelative: false,
    },
    announcementDate: {
      date: (axsEvent && axsEvent.announceDateTime) || '',
      fieldId: ANNOUNCEMENT_FIELD_ID,
      isRelative: false,
    },
    generalOnsaleDate: {
      date: (axsEvent && axsEvent.onSaleDateTime) || now,
      fieldId: ONSALE_FIELD_ID,
      isRelative: false,
    },
    eventStartDate: {
      date: event.startDate || '',
      fieldId: START_FIELD_ID,
      isRelative: false,
    },
    eventEndDate: {
      date: endDate,
      fieldId: END_FIELD_ID,
      isRelative: false,
    },
  };
  if (flag) {
    // overrride dates and make them rdat or anchors
    // need to set dateTime property for transformDateFieldToRDAT
    const flashDeliveryStartDate =
      (event.flashDeliveryDate &&
        transformDateFieldToRDAT({
          ...event.flashDeliveryDate,
          dateTime: now,
        })) ||
      dates.flashDeliveryStartDate;

    const eTicketStartDate =
      (event.eTixDeliveryDate &&
        transformDateFieldToRDAT({
          ...event.eTixDeliveryDate,
          dateTime: now,
        })) ||
      dates.eTicketStartDate;

    const standardDeliveryDate =
      (event.standardDelivery &&
        transformDateFieldToRDAT({
          ...event.standardDelivery,
          dateTime: now,
        })) ||
      dates.standardDeliveryDate;

    const eventEndDate =
      (event.eventEndDate &&
        transformDateFieldToRDAT({
          ...event.eventEndDate,
          dateTime: endDate,
        })) ||
      dates.eventEndDate;

    const eventStartDate = {
      ...dates.eventStartDate,
      dateTime: event.eventStartDate.dateTime,
    };
    const generalOnsaleDate = {
      ...dates.generalOnsaleDate,
      dateTime: dates.generalOnsaleDate.date,
    };

    Object.assign(
      dates,
      { eventEndDate },
      { eventStartDate },
      { eTicketStartDate },
      { flashDeliveryStartDate },
      { standardDeliveryDate },
      { generalOnsaleDate }
    );
  }
  delete eventCopy.eTicketDeliveryDate;
  delete eventCopy.eTixDeliveryDate;
  delete eventCopy.endDate;
  delete eventCopy.eventEndDate;
  delete eventCopy.eventStartDate;
  delete eventCopy.flashDeliveryDate;
  delete eventCopy.flashSeatsDeliveryDate;
  delete eventCopy.standardDeliveryDate;
  delete eventCopy.standardDelivery;
  delete eventCopy.generalOnsaleDate;
  delete eventCopy.onsaleDate;
  delete eventCopy.startDate;

  return Object.assign(eventCopy, { dates });
};

/**
 *
 * @param baseTemplateEvent
 * @param axsEvent
 * @param rdatFlag
 * @return {*}
 */
export const receiveAndFormatPortalTemplateBaseEvent = (
  baseTemplateEvent,
  axsEvent,
  rdatFlag
) => {
  const eventCopy = Object.assign({}, baseTemplateEvent);
  const now = Moment().format(dateFormats.API_DATE_TIME_FORMAT);
  const dates = {
    flashDeliveryStartDate: {
      date: now,
      fieldId: FLASH_FIELD_ID,
      isRelative: false,
    },
    eTicketStartDate: {
      date: now,
      fieldId: ETICKET_FIELD_ID,
      isRelative: false,
    },
    standardDeliveryDate: {
      date: now,
      fieldId: STANDARD_DELIVERY_DATE_FIELD_ID,
      isRelative: false,
    },
    announcementDate: {
      date: axsEvent.announceDateTime,
      fieldId: ANNOUNCEMENT_FIELD_ID,
      isRelative: false,
    },
    generalOnsaleDate: {
      date: axsEvent.onsaleDateTime || '',
      fieldId: ONSALE_FIELD_ID,
      isRelative: false,
    },
    eventStartDate: {
      date: axsEvent.eventDateTime,
      fieldId: START_FIELD_ID,
    },
    eventEndDate: {
      date: Moment(axsEvent.eventDateTime, dateFormats.API_DATE_TIME_FORMAT)
        .add(ONE_DAY.value, ONE_DAY.unit)
        .set(THREE_HOURS.unit, THREE_HOURS.value)
        .format(dateFormats.API_DATE_TIME_FORMAT),
      fieldId: END_FIELD_ID,
      isRelative: false,
    },
  };

  if (rdatFlag) {
    // Override dates and make them RDAT or anchors
    // need to set dateTime property for transformDateFieldToRDAT
    const flashDeliveryStartDate = baseTemplateEvent.flashDeliveryDate
      .relativeDate
      ? transformDateFieldToRDAT(baseTemplateEvent.flashDeliveryDate, true)
      : dates.flashDeliveryStartDate;
    const eTicketStartDate = baseTemplateEvent.eTixDeliveryDate.relativeDate
      ? transformDateFieldToRDAT(baseTemplateEvent.eTixDeliveryDate, true)
      : dates.eTicketStartDate;
    const standardDeliveryDate =
      baseTemplateEvent.standardDelivery &&
      baseTemplateEvent.standardDelivery.relativeDate
        ? transformDateFieldToRDAT(baseTemplateEvent.standardDelivery, true)
        : dates.standardDeliveryDate;
    const eventEndDate = baseTemplateEvent.eventEndDate.relativeDate
      ? transformDateFieldToRDAT(baseTemplateEvent.eventEndDate, true)
      : dates.eventEndDate;

    Object.assign(
      dates,
      { eventEndDate },
      { eTicketStartDate },
      { flashDeliveryStartDate },
      { standardDeliveryDate }
    );
  }

  delete eventCopy.eTicketDeliveryDate;
  delete eventCopy.eTixDeliveryDate;
  delete eventCopy.endDate;
  delete eventCopy.eventEndDate;
  delete eventCopy.eventStartDate;
  delete eventCopy.flashDeliveryDate;
  delete eventCopy.flashSeatsDeliveryDate;
  delete eventCopy.standardDeliveryDate;
  delete eventCopy.standardDelivery;
  delete eventCopy.generalOnsaleDate;
  delete eventCopy.onsaleDate;
  delete eventCopy.startDate;
  return Object.assign(eventCopy, { dates });
};

export const receiveAndFormatZones = (event, flag) => {
  if (event.zones.length < 1) {
    return [];
  }
  return event.zones.map((zone) => {
    if (zone.printTemplates && zone.printTemplates.length > 0) {
      let printTempsArr = [];

      zone.printTemplates.forEach((el) => {
        printTempsArr.push('' + el.templateId);
      });

      zone.printTemplateIds = printTempsArr;
    }
    const newZoneObj = Object.assign({}, zone);
    const dates = {
      accessControlEndDate: {
        date: zone.accessControlEndDateTime || '',
        fieldId: ACCESS_END_FIELD_ID,
        isRelative: false,
      },

      accessControlStartDate: {
        date: zone.accessControlStartDateTime || '',
        fieldId: ACCESS_START_FIELD_ID,
        isRelative: false,
      },
    };
    if (!flag) {
      delete newZoneObj.accessControlEndDateTime;
      delete newZoneObj.accessControlStartDateTime;
      delete newZoneObj.eTicketStartDateTime;
    } else {
      delete newZoneObj.accessControlEndDateTime;
      delete newZoneObj.accessControlEndDate;
      delete newZoneObj.accessControlStartDateTime;
      delete newZoneObj.accessControlStartDate;
      delete newZoneObj.eTicketStartDateTime;

      const accessControlStartDate =
        (zone.accessControlStartDate &&
          transformDateFieldToRDAT(zone.accessControlStartDate)) ||
        dates.accessControlStartDate;
      const accessControlEndDate =
        (zone.accessControlEndDate &&
          transformDateFieldToRDAT(zone.accessControlEndDate)) ||
        dates.accessControlEndDate;
      Object.assign(
        dates,
        { accessControlStartDate },
        { accessControlEndDate }
      );
    }
    return Object.assign({}, newZoneObj, { dates });
  });
};
export const receiveAndFormatOfferGroups = (
  offer,
  flag,
  isIncomplete,
  onPrices
) => {
  return (
    offer.groups &&
    offer.groups.map((group) => {
      const newPriceCodes = group.priceCodes.map((pcode) => {
        const pcodeCopy = Object.assign({}, pcode);
        let startDate = {};
        let endDate = {};
        if (flag) {
          startDate =
            pcode.startDate &&
            transformDateFieldToRDAT(pcode.startDate, isIncomplete, onPrices);
          endDate =
            pcode.endDate &&
            transformDateFieldToRDAT(pcode.endDate, isIncomplete, onPrices);
        } else {
          startDate = {
            dateTime: flag
              ? pcodeCopy.startDate.dateTime
              : pcodeCopy.onSaleDate,
            fieldId: PRICE_CODE_START_FIELD_ID,
          };
          endDate = {
            dateTime: flag ? pcodeCopy.endDate.dateTime : pcodeCopy.offSaleDate,
            fieldId: PRICE_CODE_END_FIELD_ID,
          };
        }

        delete pcodeCopy.startDate;
        delete pcodeCopy.endDate;

        return Object.assign(pcodeCopy, { startDate }, { endDate });
      });
      const newPriceLevels = group.priceLevels.map((pLevel) => {
        const pLevelCopy = Object.assign({}, pLevel);
        let startDate = {};
        let endDate = {};

        if (flag) {
          startDate =
            pLevel.startDate &&
            transformDateFieldToRDAT(pLevel.startDate, isIncomplete, onPrices);
          endDate =
            pLevel.endDate &&
            transformDateFieldToRDAT(pLevel.endDate, isIncomplete, onPrices);
          // Object.assign(dates, { startDate }, { endDate });
        } else {
          startDate = {
            dateTime: flag
              ? pLevelCopy.startDate.dateTime
              : pLevelCopy.onSaleDate,
            fieldId: PRICE_LEVEL_START_FIELD_ID,
          };
          endDate = {
            dateTime: flag
              ? pLevelCopy.endDate.dateTime
              : pLevelCopy.offSaleDate,
            fieldId: PRICE_LEVEL_END_FIELD_ID,
          };
        }

        delete pLevelCopy.startDate;
        delete pLevelCopy.endDate;
        return Object.assign(pLevelCopy, { startDate }, { endDate });
      });
      Object.assign(
        group,
        { priceLevels: newPriceLevels },
        { priceCodes: newPriceCodes }
      );
      return group;
    })
  );
};

const removeUnnecessaryFields = (dateObj) => {
  if (!dateObj.dateTime) {
    return {
      date: '',
      fieldId: dateObj.fieldId,
      id: dateObj.id,
      isRelative: false,
    };
  }
  return dateObj;
};
export const receiveAndFormatPortalOnlyEvent = (portalEvent) => {
  const dates = {
    flashDeliveryStartDate: {
      date: '',
      fieldId: FLASH_FIELD_ID,
      isRelative: false,
    },
    eTicketStartDate: {
      date: '',
      fieldId: ETICKET_FIELD_ID,
      isRelative: false,
    },
    standardDeliveryDate: {
      date: '',
      fieldId: STANDARD_DELIVERY_DATE_FIELD_ID,
      isRelative: false,
    },
    announcementDate: {
      date: '',
      fieldId: ANNOUNCEMENT_FIELD_ID,
      isRelative: false,
    },
    generalOnsaleDate: {
      date: '',
      fieldId: ONSALE_FIELD_ID,
      isRelative: false,
    },
    eventStartDate: {
      date: (portalEvent.aXSEvent && portalEvent.aXSEvent.eventDateTime) || '',
      fieldId: START_FIELD_ID,
      isRelative: false,
    },
    eventEndDate: {
      date: '',
      fieldId: END_FIELD_ID,
      isRelative: false,
    },
  };
  return dates;
};
const setTemplateDates = (event) => {
  return {
    flashDeliveryStartDate: {
      date: event.flashDeliveryStartDate.date || '',
      fieldId: FLASH_FIELD_ID,
      isRelative: false,
    },
    eTicketStartDate: {
      date: event.eTicketStartDate.date || '',
      fieldId: ETICKET_FIELD_ID,
      isRelative: false,
    },
    standardDeliveryDate: {
      date: event.standardDeliveryDate.date || '',
      fieldId: STANDARD_DELIVERY_DATE_FIELD_ID,
      isRelative: false,
    },
    announcementDate: {
      date: (event.aXSEvent && event.aXSEvent.announceDateTime) || '',
      fieldId: ANNOUNCEMENT_FIELD_ID,
      isRelative: false,
    },
    expirationDate: {
      date: '',
      fieldId: null,
      isRelative: false,
    },
    generalOnsaleDate: {
      date: event.generalOnsaleDate.date || '',
      fieldId: ONSALE_FIELD_ID,
      isRelative: false,
    },
    eventStartDate: {
      date: event.eventStartDate.date || '',
      fieldId: START_FIELD_ID,
      isRelative: false,
    },
    eventEndDate: {
      date: event.eventEndDate.date || '',
      fieldId: END_FIELD_ID,
      isRelative: false,
    },
  };
};
export const receiveAndFormatTemplateDates = (event, relativeDates, flag) => {
  const eventCopy = Object.assign({}, event);
  const dates = setTemplateDates(event);

  if (flag) {
    const eTicketStartDate =
      (find(relativeDates, { fieldId: ETICKET_FIELD_ID }) &&
        transformDateFieldToRDAT(
          find(relativeDates, { fieldId: ETICKET_FIELD_ID }),
          true
        )) ||
      dates.eTicketStartDate;
    eTicketStartDate.date =
      event.eTicketStartDate && event.eTicketStartDate.date;

    const eventEndDate =
      (find(relativeDates, { fieldId: END_FIELD_ID }) &&
        transformDateFieldToRDAT(
          find(relativeDates, { fieldId: END_FIELD_ID }),
          true
        )) ||
      dates.eventEndDate;
    eventEndDate.date = event.eventEndDate && event.eventEndDate.date;

    const flashDeliveryStartDate =
      (find(relativeDates, { fieldId: FLASH_FIELD_ID }) &&
        transformDateFieldToRDAT(
          find(relativeDates, { fieldId: FLASH_FIELD_ID }),
          true
        )) ||
      dates.flashDeliveryStartDate;
    flashDeliveryStartDate.date =
      event.flashDeliveryStartDate && event.flashDeliveryStartDate.date;

    const standardDeliveryDate =
      (find(relativeDates, { fieldId: STANDARD_DELIVERY_DATE_FIELD_ID }) &&
        transformDateFieldToRDAT(
          find(relativeDates, { fieldId: STANDARD_DELIVERY_DATE_FIELD_ID }),
          true
        )) ||
      dates.standardDeliveryDate;
    standardDeliveryDate.date =
      event.standardDeliveryDate && event.standardDeliveryDate.date;

    Object.assign(
      dates,
      { eventEndDate },
      { eTicketStartDate },
      { flashDeliveryStartDate },
      { standardDeliveryDate }
    );
  }
  delete eventCopy.eTicketDeliveryDate;
  delete eventCopy.eTixDeliveryDate;
  delete eventCopy.endDate;
  delete eventCopy.eventEndDate;
  delete eventCopy.eventStartDate;
  delete eventCopy.flashDeliveryDate;
  delete eventCopy.flashSeatsDeliveryDate;
  delete eventCopy.standardDeliveryDate;
  delete eventCopy.standardDelivery;
  delete eventCopy.generalOnsaleDate;
  delete eventCopy.onsaleDate;
  delete eventCopy.startdate;
  return Object.assign(eventCopy, { dates });
};
export const formatReceieveOfferDates = (offer, isIncomplete, flag) => {
  const dates = {
    startDate: {
      date: isIncomplete ? '' : offer.onSaleDate,
      fieldId: OFFER_START_FIELD_ID,
    },
    endDate: {
      date: isIncomplete ? '' : offer.offSaleDate,
      fieldId: OFFER_END_FIELD_ID,
    },
  };
  if (flag) {
    // offer dates for incomplete offers that have RDAT values are to be displayed,
    // not ignored like non rdat incomplete offer date values
    const startDate = transformDateFieldToRDAT(offer.startDate, isIncomplete);
    const endDate = transformDateFieldToRDAT(offer.endDate, isIncomplete);
    return Object.assign(dates, { startDate }, { endDate });
  }
  return dates;
};

/**
   * ONLY USED FOR PRICE CODES
   * 4 scenarios :
   * 1. Incomplete offers, non rdats === default to empty string
   * 2. Incomplete offers, with rdats === re-calculate relative date
   * 3. Complete offers , with rdats = don't calculate, display date values
   * 4. Complete offers, without rdats = display date values as normal

   * @param { object } dateObject - date object on which rdat formula must be applied
   * @param { object } generalOnsaleDate - gosd date object(anchor date)
   * @param { object } eventStartDate - event start date object(anchor date)
   * @param { bool } flag - flag indicating if relative dates is enabled
   * @returns { object }
   */
export const updateAndRecalculateRdat = (
  dateObj,
  generalOnsaleDate,
  eventStartDate,
  flag
) => {
  if ((dateObj && !dateObj.isRelative && flag) || !flag) {
    /*
      if date isn't relative or flag is off, return empty string
      or date is an empty string or date object is not present
      this can happen when we save a price codes by selecting all / payload we receive from the
      server will not have a date object.
    */
    if (dateObj.date === '' || !dateObj.date) {
      return '';
    }
    return formatDateTimeForAPI(dateObj.date);
  }
  const anchorDate =
    dateObj.anchor === START_FIELD_ID
      ? eventStartDate.date
      : generalOnsaleDate.date;
  const {
    operator,
    specificTime,
    months,
    weeks,
    days,
    hours,
    minutes,
  } = dateObj;
  return calculateRelativeDate(
    anchorDate,
    operator,
    months,
    weeks,
    days,
    hours,
    minutes,
    specificTime
  );
};

/**
 * Receives Offer Promo Visibility dates from the API and transforms them to FE RDAT
 * format.
 *
 * @param promo
 * @param flag
 * @returns {*}
 */
export const formatReceiveOfferPromoVisibilityDates = (promo, flag) => {
  const dates = {
    visibleStartDate: {
      date: promo.visibleStartDate ? promo.visibleStartDate.dateTime : '',
      fieldId: PROMO_VISIBLE_START_DATE,
    },
    visibleEndDate: {
      date: promo.visibleEndDate ? promo.visibleEndDate.dateTime : '',
      fieldId: PROMO_VISIBLE_END_DATE,
    },
  };
  if (flag && promo.visibleStartDate) {
    const visibleStartDate = transformDateFieldToRDAT(
      promo.visibleStartDate,
      false
    );
    const visibleEndDate = transformDateFieldToRDAT(
      promo.visibleEndDate,
      false
    );
    return Object.assign(dates, { visibleStartDate }, { visibleEndDate });
  }
  delete promo.visibleStartDate;
  delete promo.visibleEndDate;
  return dates;
};



// WEBPACK FOOTER //
// ./src/common/lib/ReceiveAndFormatDates.js